export const alphabet = 'ABCDEFGHIGKLMNOPQRSTUVWXYZ'.split('');
